import userStepsDataDetailReducer from './userStepsDataDetailReducer.jsx';
import myImagesDownloadReducer from './downloadImagesReducer.jsx';

const combinedReducers = Object.freeze({
  userStepsDataDetailReducer: userStepsDataDetailReducer?.reducer,
  myImagesDownloadReducer: myImagesDownloadReducer?.reducer,
});

export default combinedReducers;
